// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".action-catalog>h1.title{font-size:20px;font-weight:lighter;padding:0 10px}.action-catalog>h2.title{font-size:16px;font-weight:lighter;padding:0 20px}.action-catalog .offers-container{display:flex;flex-wrap:wrap;justify-content:space-around}.action-catalog>.empty-label{font-size:16px;font-weight:lighter;padding:5px;text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
